import { Button } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import { endpoint } from "@/api";
import appConfig from "@/config/appConfig";
import CustomReportTemplateLayout from "./CustomReportTemplateLayout";

const CustomReportTemplateView = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { isDark } = useSelector((state) => state.theme);

  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [layouts, setLayouts] = useState({});

  const getCustomReportTemplate = async () => {
    if (!isLoading) {
      setIsLoading(true);
      const response = await axios.get(endpoint.customReportTemplate + "/" + id, { withCredentials: true });
      if (response.status === 200) {
        setData(response.data.result);
        setLayouts(response.data.result.layouts);
        setIsLoading(false);
      }
    }
  };

  useEffect(() => {
    getCustomReportTemplate();
  }, [id]);

  useEffect(() => {
    document.title = `${appConfig.name} - Report`;
  }, []);

  return (
    <div className="px-md-3 mt-3">
      <div className="border p-3">
        {/* <h5>Report List</h5> */}
        <div className="d-flex align-items-center justify-content-between">
          <div>
            <label className="az-content-label">Manage Report Template</label>
            <span className="d-block py-2">View Report Template: {data?.name}</span>

            <div className="pb-2"> {data?.description} </div>
          </div>
        </div>
        <hr className="mt-0 mb-5" />
        <div className="pb-5 px-3">
          <div className="bg-layout" style={{ filter: isDark ? "invert(.9)" : "" }}>
            {data.data?.length !== 0 ? (
              <>
                <CustomReportTemplateLayout
                  gridData={data.items}
                  layouts={layouts}
                  setLayouts={setLayouts}
                  mode="view"
                />
              </>
            ) : (
              <div>No Data Found</div>
            )}
          </div>
          <div className="d-flex justify-content-end mt-3 gap-2">
            <Link to={`/edit-report-template/${id}`} className="d-none d-md-inline">
              <Button type="primary"> Edit </Button>
            </Link>
            <Button onClick={() => navigate(-1)} type="primary" className="bg-secondary">
              Back
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomReportTemplateView;
